module.exports = __webpack_public_path__ + "static/running-blind-60a50da112ba6a9593d491c8621e5141.jpg";